import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";

import { BsSearch } from "react-icons/bs";

import classes from "./MessagesPage.module.css";
import { setHoldPulling } from "../../Store/actions";
import { Card } from "react-bootstrap";

const ASSETES = {
  pcariUser: "/svg/pcariMainToolBarLogo.svg",
};

const huminizeDate = (date) => {
  const delta = Math.round((+new Date() - date) / 1000);

  const minute = 60,
    hour = minute * 60,
    day = hour * 24;
  let fuzzy;

  if (delta < 30) {
    fuzzy = "just now";
  } else if (delta < minute) {
    fuzzy = delta + " seconds ago.";
  } else if (delta < 2 * minute) {
    fuzzy = "a minute ago.";
  } else if (delta < hour) {
    fuzzy = Math.floor(delta / minute) + " minutes ago.";
  } else if (Math.floor(delta / hour) === 1) {
    fuzzy = "1 hour ago.";
  } else if (delta < day) {
    fuzzy = Math.floor(delta / hour) + " hours ago.";
  } else if (delta < day * 2) {
    fuzzy = "yesterday";
  } else if (delta >= day * 2) {
    fuzzy = new Date(date).toString().slice(4, 15);
  }
  return fuzzy;
};

const MessagesPage = ({ messages, bigScreen, setChatId, chatId }) => {
  const dispatch = useDispatch();

  const router = useHistory();

  const currentUser = useSelector((state) => state.Auth.currentUser);

  const { holdPulling } = useSelector((state) => state.Chat);

  const [searchName, setSearchName] = useState("");
  let renderMessages = null;
  if (messages) {
    renderMessages = messages.map((chat) => {
      const chatMessageLength = chat.chat_messages.length;

      let participantId, participantName, participantImg;

      let participant = {};

      try {
        participant =
          chat.chat_participants[0].id === currentUser.id
            ? chat.chat_participants[1]
            : chat.chat_participants[0];

        participantId = participant.id;

        participantName = participant.name;

        participantImg = participant.profile_picture;
      } catch {
        participant = chat.chat_participants[0];

        participantId = participant.id;

        participantName = participant.name;

        participantImg = participant.profile_picture;
      }

      participantId = participant.id;

      participantName = participant.name;

      participantImg = participant.profile_picture;

      const lastMessage = chat.chat_messages[chatMessageLength - 1];

      const messageTime = new Date(lastMessage.created_at).getTime();

      const timeAgo = huminizeDate(messageTime);
      if (
        participantName
          ? participantName
          : "".toLowerCase().includes(searchName.toLowerCase())
      )
        return (
          <div
            key={chat.id}
            className={`${classes.ChatWrapper} ${
              chat.id === chatId ? classes.selected : null
            }`}
          >
            <img src={participantImg} alt="user" />

            <div
              className={classes.Chat}
              onClick={(event) => {
                event.preventDefault();
                setChatId(chat.id);
                if (!bigScreen) {
                  router.push({
                    pathname: "chat",
                    state: { id: chat.id },
                  });
                }
                if (holdPulling) dispatch(setHoldPulling(false));
              }}
            >
              <div className={classes.Dealer}>
                <h1>{participantName}</h1>
              </div>

              <div className={classes.LatestMess}>
                <p>
                  <label>
                    {lastMessage.user_id === participantId
                      ? participantName + " :"
                      : "You :"}
                  </label>
                  {lastMessage.message}
                </p>
                <label>{timeAgo}</label>
              </div>
            </div>
          </div>
          // </Link>
        );
    });
  }
  return (
    <Card className="shadow-sm" style={{ borderRadius: "11px" }}>
      <Card.Body>
        <h5>Inbox</h5>
        <div className={classes.SearchName}>
          <input
            type="text"
            placeholder="Search people"
            value={searchName}
            onChange={(event) => setSearchName(event.target.value)}
          />
          <span>
            <BsSearch />
          </span>
        </div>
        {renderMessages}
      </Card.Body>
    </Card>
  );
};

export default MessagesPage;
